import ES_DNI_IMAGE from 'assets/icons/dni-front.svg';
import ES_CUE_IMAGE from 'assets/images/documentation/cue-front-shadow.svg';
import NIE_FRONT_IMAGE from 'assets/images/documentation/nie-front-shadow.png';
import PASSPORT_FRONT_IMAGE from 'assets/images/documentation/passport-front-shadow.png';
import PT_ID_FRONT_IMAGE from 'assets/images/documentation/pt-id-front-shadow.png';

export const translations = {
    IDENTIFICATION_MORE_DETAILS_TITLE: 'newUserRequirements-moreDetailsTitle',
    IDENTIFICATION_MORE_DETAILS_ID_TITLE: 'newUserRequirements-moreDetailsId',
    IDENTIFICATION_MORE_DETAILS_ID_DESCRIPTION: 'newUserRequirements-moreDetailsIdDescription',
    IDENTIFICATION_MORE_DETAILS_ID_IMAGE_ALT: 'newUserRequirements-moreDetailsIdImageAlt',
    IDENTIFICATION_MORE_DETAILS_PASSPORT_TITLE: 'newUserRequirements-moreDetailsPassport',
    IDENTIFICATION_MORE_DETAILS_PASSPORT_DESCRIPTION: 'newUserRequirements-moreDetailsPassportDescription',
    IDENTIFICATION_MORE_DETAILS_PASSPORT_IMAGE_ALT: 'newUserRequirements-moreDetailsPassportImageAlt',
    IDENTIFICATION_MORE_DETAILS_CUE_IMAGE_ALT: 'newUserRequirements-moreDetailsCueImageAlt',
    IDENTIFICATION_MORE_DETAILS_TIE_TITLE: 'newUserRequirements-moreDetailsTie',
    IDENTIFICATION_MORE_DETAILS_TIE_DESCRIPTION: 'newUserRequirements-moreDetailsTieDescription',
    IDENTIFICATION_MORE_DETAILS_TIE_IMAGE_ALT: 'newUserRequirements-moreDetailsTieImageAlt',
    CLOSE_BUTTON: 'newUserRequirements-moreDetailsCloseButton',
};

export const IDENTIFICATION_MORE_DETAILS_SPAIN = {
    title: translations.IDENTIFICATION_MORE_DETAILS_TITLE,
    details: [
        {
            images: [{ img: ES_DNI_IMAGE, description: translations.IDENTIFICATION_MORE_DETAILS_ID_IMAGE_ALT }],
            title: translations.IDENTIFICATION_MORE_DETAILS_ID_TITLE,
            description: translations.IDENTIFICATION_MORE_DETAILS_ID_DESCRIPTION,
        },
        {
            images: [
                {
                    img: PASSPORT_FRONT_IMAGE,
                    description: translations.IDENTIFICATION_MORE_DETAILS_PASSPORT_IMAGE_ALT,
                },
                {
                    img: ES_CUE_IMAGE,
                    description: translations.IDENTIFICATION_MORE_DETAILS_CUE_IMAGE_ALT,
                },
            ],
            title: translations.IDENTIFICATION_MORE_DETAILS_PASSPORT_TITLE,
            description: translations.IDENTIFICATION_MORE_DETAILS_PASSPORT_DESCRIPTION,
        },
        {
            images: [
                {
                    img: NIE_FRONT_IMAGE,
                    description: translations.IDENTIFICATION_MORE_DETAILS_TIE_IMAGE_ALT,
                },
            ],
            title: translations.IDENTIFICATION_MORE_DETAILS_TIE_TITLE,
            description: translations.IDENTIFICATION_MORE_DETAILS_TIE_DESCRIPTION,
        },
    ],
};

export const IDENTIFICATION_MORE_DETAILS_OTHER_COUNTRIES = {
    title: translations.IDENTIFICATION_MORE_DETAILS_TITLE,
    details: [
        {
            images: [
                {
                    img: PT_ID_FRONT_IMAGE,
                    description: translations.IDENTIFICATION_MORE_DETAILS_ID_IMAGE_ALT,
                },
            ],
            title: translations.IDENTIFICATION_MORE_DETAILS_ID_TITLE,
            description: translations.IDENTIFICATION_MORE_DETAILS_ID_DESCRIPTION,
        },
        {
            images: [
                {
                    img: PASSPORT_FRONT_IMAGE,
                    description: translations.IDENTIFICATION_MORE_DETAILS_PASSPORT_IMAGE_ALT,
                },
            ],
            title: translations.IDENTIFICATION_MORE_DETAILS_PASSPORT_TITLE,
            description: translations.IDENTIFICATION_MORE_DETAILS_PASSPORT_DESCRIPTION,
        },
    ],
};
